import React, { useState, useEffect, useMemo } from "react";
import {
  ChevronDown,
  ChevronRight,
  DatabaseBackup,
  LogOut,
  ChartNoAxesCombined,
  Search,
  Dock,
  FileText,
  Clock,
} from "lucide-react";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { removeToken } from "../hooks/useAuth";

export default function Sidebar({ collapsed }) {
  const [openMenus, setOpenMenus] = useState({});

  // Đăng xuất người dùng
  const navigate = useNavigate();

  const userName = "TOMOTEK";
  const userPhone = "admin";

  // Tạo avatar URL từ tên user
  const avatarName = useMemo(() => {
    if (!userName) return "User";
    // Lấy chữ cái đầu của từ cuối cùng trong tên
    const nameParts = userName.trim().split(/\s+/);
    return nameParts[nameParts.length - 1] || "User";
  }, [userName]);

  const handleLogout = () => {
    navigate("/login");
    removeToken();
    window.location.reload();
  };

  // Khi collapse → đóng tất cả
  useEffect(() => {
    if (collapsed) setOpenMenus({});
  }, [collapsed]);

  const toggleMenu = (key) => setOpenMenus((prev) => ({ [key]: !prev[key] }));

  // 📁 Cấu trúc menu chính
  const menuItems = [
    {
      name: "Real Time",
      href: "/realtime",
      icon: <Clock size={20} />,
    },
    {
      name: "History",
      href: "/history",
      icon: <ChartNoAxesCombined size={20} />,
    },
    {
      name: "Raw Data",
      href: "/raw-data",
      icon: <DatabaseBackup size={20} />,
    },

    {
      name: "Report",
      href: "/report",
      icon: <FileText size={20} />,
    },

    {
      name: "Device",
      href: "/device",
      icon: <Dock size={20} />,
    },
  ];

  // 🎨 Class chung
  const linkBase =
    "flex items-center gap-2 p-2 rounded text-sm font-medium transition-all duration-200 text-gray-700";
  const hoverStyle = "hover:bg-primary/10 hover:text-primary";
  const activeStyle = "bg-primary text-white";

  // ⚙️ Render từng item
  const renderMenuItem = (item) => {
    if (item.children) {
      const isOpen = openMenus[item.key || item.name];
      return (
        <div key={item.name} className="space-y-1">
          {/* Nhóm header */}
          <div
            onClick={() => toggleMenu(item.key || item.name)}
            className={`${linkBase} cursor-pointer ${hoverStyle}`}
          >
            {item.icon}
            {!collapsed && <span className="flex-1">{item.name}</span>}
            {!collapsed &&
              (isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />)}
          </div>

          {/* Submenu */}
          {!collapsed && isOpen && (
            <div className="ml-6 mt-1 space-y-1 border-l border-gray-300 pl-2">
              {item.children.map((child) => (
                <NavLink
                  key={child.name}
                  to={child.href}
                  end
                  className={({ isActive }) =>
                    `${linkBase} ${hoverStyle} ${isActive ? activeStyle : ""}`
                  }
                >
                  {child.icon}
                  {child.name}
                </NavLink>
              ))}
            </div>
          )}
        </div>
      );
    }

    return (
      <NavLink
        key={item.name}
        to={item.href}
        end
        className={({ isActive }) =>
          `${linkBase} ${hoverStyle} ${isActive ? activeStyle : ""}`
        }
      >
        {item.icon}
        {!collapsed && <span>{item.name}</span>}
      </NavLink>
    );
  };

  return (
    <aside
      className={`bg-white border-r border-gray-200 text-gray-700 flex flex-col justify-between transition-all duration-300 ${
        collapsed ? "w-20" : "w-64"
      }`}
    >
      {/* 👤 USER INFO */}
      <div>
        <div className="flex justify-center items-center p-4 border-b border-gray-200">
          {collapsed ? (
            <span className="text-2xl font-bold text-primary">≡</span>
          ) : (
            <div className="flex items-center gap-3">
              <img
                src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                  avatarName
                )}&background=7D7ACC&color=fff`}
                alt="avatar"
                className="w-10 h-10 rounded-full border-2 border-gray-200"
              />
              <div>
                <p className="text-sm font-semibold text-gray-900">
                  {userName || "Người dùng"}
                </p>
                <p className="text-xs text-gray-500">
                  {userPhone || "Chưa cập nhật"}
                </p>
              </div>
            </div>
          )}
        </div>

        {/* 🧭 MENU */}
        <nav className="flex flex-col p-4 space-y-2 overflow-y-auto max-h-[calc(100vh-140px)] scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
          {menuItems.map(renderMenuItem)}
        </nav>
      </div>

      {/* ⚙️ FOOTER */}
      {!collapsed && (
        <div className="flex items-center justify-between border-t border-gray-200 p-4 text-xs text-gray-600">
          <span>© Tomotek</span>
          <button
            className="flex items-center gap-1 hover:text-primary transition-colors"
            onClick={handleLogout}
          >
            <LogOut size={16} /> Đăng xuất
          </button>
        </div>
      )}
    </aside>
  );
}
